export enum LocaleEnum {
	FR_BE = 'fr-BE',
	NL_BE = 'nl-BE',
}
